"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformVehicleTypeToPassengersRangeString = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const transformVehicleTypeToPassengersRangeString = (vehicleType) => {
    let passengerRange = "";
    switch (vehicleType) {
        case legacy_enums_1.VehicleType.Sedan:
            passengerRange = "1-3";
            break;
        case legacy_enums_1.VehicleType.LuxurySedan:
            passengerRange = "1-3";
            break;
        case legacy_enums_1.VehicleType.SedanLite:
            passengerRange = "1-3";
            break;
        case legacy_enums_1.VehicleType.Mpv:
            passengerRange = "4";
            break;
        case legacy_enums_1.VehicleType.MpvLite:
            passengerRange = "4";
            break;
        case legacy_enums_1.VehicleType.Van:
            passengerRange = "5-7";
            break;
        case legacy_enums_1.VehicleType.VanLite:
            passengerRange = "5-7";
            break;
        case legacy_enums_1.VehicleType.Shuttle:
            passengerRange = "7-10";
            break;
        default:
            passengerRange = "1-10";
            break;
    }
    return passengerRange;
};
exports.transformVehicleTypeToPassengersRangeString = transformVehicleTypeToPassengersRangeString;
//# sourceMappingURL=transformVehicleTypeToPassengersRangeString.js.map